module.exports = __webpack_public_path__ + "static/meister-2c3df3ef16e23af4e3c7edaabd0c0ebe.png";